import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { VideoTheme } from '../../../types/entities';
import VideoMatriseComponent, {} from '../../../videomatrise';
import { PortableTextContext } from '../../portable-text-content';
const VideoMatriseBlock = ({ value }) => {
    const backgroundColor = useContext(PortableTextContext)?.backgroundColor;
    return (_jsx(VideoMatriseComponent, { title: value.title, videoCards: value.videoCards, cardsPerRow: value.cardsPerRow, theme: backgroundColor && isVideoThemeColor(backgroundColor) ? backgroundColor : value.theme, resources: value.resources }));
};
function isVideoThemeColor(value) {
    return Object.values(VideoTheme).includes(value);
}
export default VideoMatriseBlock;
